import { request } from "./request";

export function getTemplateEventList(params) {
  return request.post("/platform/v3/template_event_list", params);
}

export function getDeviceLogs(params) {
  return request.post("platform/v3/logs", params);
}
